import React, { useEffect, useState } from 'react';
import ModalLayout from './ModalLayout';
import {
  fetchNotifications,
  markNotificationsAsRead,
} from '../../api/notifications';

const NotificationSkeleton = () => (
  <div className="mb-2 flex animate-pulse justify-between rounded-lg bg-gray-100 p-3">
    <div className="w-full">
      <div className="h-8 w-1/3 rounded bg-gray-300"></div>
      <div className="mt-2 h-4 w-2/3 rounded bg-gray-300"></div>
    </div>
    <div className="h-5 w-1/4 rounded bg-gray-300"></div>
  </div>
);

const EventLogModal = ({
  deviceId,
  closeModal,
  updateUnreadNotificationsCount,
}) => {
  const [notifications, setNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [notificationsPerPage] = useState(6);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false); // Loading state

  const fetchNotificationsData = async (page) => {
    setLoading(true);
    try {
      const response = await fetchNotifications(
        page * notificationsPerPage,
        notificationsPerPage,
        deviceId
      );
      setNotifications(response.data);
      setTotalPages(Math.ceil(response.total_records / notificationsPerPage));
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotificationsData(currentPage - 1);
  }, [currentPage]);

  useEffect(() => {
    const unreadNotifications = notifications.filter((n) => !n.seen);
    if (unreadNotifications.length > 0) {
      const updatedNotifications = notifications.map((n) => ({
        ...n,
        seen: true,
      }));
      setTimeout(() => {
        setNotifications(updatedNotifications);
        markNotificationsAsRead(unreadNotifications.map((n) => n.id));
        updateUnreadNotificationsCount &&
          updateUnreadNotificationsCount(
            updatedNotifications.filter((n) => !n.seen).length
          );
      }, 1000);
    }
  }, [notifications]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <ModalLayout closeModal={closeModal} className="w-full">
      <h2 className="mb-4 text-xl font-bold text-gray-800">
        Журнал событий
        {deviceId ? ' устройства' : ' устройств'}
      </h2>
      <div className="min-h-[48dvh] p-2">
        <div className="">
          {loading ? ( // Show skeleton loader while loading
            [...Array(notificationsPerPage)].map((_, index) => (
              <NotificationSkeleton key={index} />
            ))
          ) : notifications.length > 0 ? ( // Show actual notifications
            notifications.map((notification, index) => (
              <div
                key={index}
                className={`mb-2 flex gap-2 justify-between rounded-lg p-3 transition-colors ${
                  notification.seen ? 'bg-gray-100' : 'bg-blue-100'
                }`}
              >
                <div>
                  <div className="bg-zinc-200 text-xs px-2 py-1 rounded-lg">
                    {notification.device_name}{' '}
                    <span className="text-xs text-gray-400">
                      {notification.device_id}
                    </span>
                  </div>
                  <p className="text-base">{notification.message}</p>
                </div>
                <p className="mt-0 text-sm text-gray-500">
                  {new Date(notification.timestamp_ms).toLocaleString('ru-RU')}
                </p>
              </div>
            ))
          ) : (
            <p>Нет новых уведомлений.</p>
          )}
        </div>

        {totalPages > 1 && (
          <div className="mt-4 flex items-center justify-center space-x-2">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1 || loading}
              className="btn-header px-4 disabled:opacity-50"
            >
              ←
            </button>
            <span className="text-sm">
              Страница {currentPage} из {totalPages}
            </span>
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages || loading}
              className="btn-header px-4 disabled:opacity-50"
            >
              →
            </button>
          </div>
        )}
      </div>
    </ModalLayout>
  );
};

export default EventLogModal;
